import { render } from "./Date.vue?vue&type=template&id=1f9014e2&ts=true"
import script from "./Date.vue?vue&type=script&lang=ts"
export * from "./Date.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__